<app-header></app-header>
<div class="body-container clearfix">
    <div class="row">
        <div class="col-12">
            <div class="component-container">
                <div class="container congratulations">
                    <div class="row">
                        <div class="col-12">
                            <img src="/assets/images/icons/approved_icon.svg" alt="add equipment" />
                        </div>
                    </div>
                    <div class="row title">
                        <div class="col-12 font-mont-book">
                            Congratulations!
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 font-mont-book">
                            Your customer, [customer name], has been approved for $X.XXX. The monthly payment will be
                            $XXX/month for xx months.
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 font-mont-book">
                            You aren't quite finished!
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 font-mont-book">
                            Complete the document verification
                        </div>
                        <div class="col-12 font-mont-book">
                            below to submit the contract.
                        </div>
                    </div>
                </div>
                <hr>
                <div class="container upload-documents">
                    <div class="row title">
                        <div class="col-12 font-mont-book">
                            Upload documents
                        </div>
                    </div>
                    <div class="row upload-legend">
                        <div class="col-12 font-mont-book">
                            Upload the completed lease agreement and the
                        </div>
                        <div class="col-12 font-mont-book">
                            applicant's driver's license.
                        </div>
                    </div>
                    <div class="row document-uploaders"
                        *ngIf="!uploadedSignedContract || !uploadedVoidedCheck || !uploadedFrontDL || !uploadedBackDL ">
                        <div class="col-12 font-mont-book">
                            Drag and drop or click on + to upload
                        </div>
                    </div>
                    <div class="row document-uploaders">
                        <div class="col-3 font-mont-book">
                            <app-upload-document (onFileAdded)="onSignedContractAdded($event);"
                                (onClick)="onSignedContractClick()" [elementId]="'uploadSignedContract'" [lineA]="''"
                                [lineB]="''" [uploaded]="uploadedSignedContract" [customClass]="'signed-contract'">
                            </app-upload-document>
                        </div>
                        <div class="col-3 font-mont-book">
                            <app-upload-document (onFileAdded)="onVoidedCheckAdded($event);"
                                [elementId]="'uploadVoidedCheck'" [lineA]="''" [lineB]="''"
                                [uploaded]="uploadedVoidedCheck" [customClass]="'voided-check'">
                            </app-upload-document>
                        </div>
                        <div class="col-3 font-mont-book">
                            <app-upload-document (onFileAdded)="onFrontDLAdded($event);" [elementId]="'uploadFrontDL'"
                                [lineA]="'Front'" [lineB]="''" [uploaded]="uploadedFrontDL"
                                [customClass]="'driver-license'">
                            </app-upload-document>
                        </div>
                        <div class="col-3 font-mont-book">
                            <app-upload-document (onFileAdded)="onBackDLAdded($event);" [elementId]="'uploadBackDL'"
                                [lineA]="'Back'" [lineB]="''" [uploaded]="uploadedBackDL"
                                [customClass]="'driver-license'">
                            </app-upload-document>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3 font-mont-book document-type" [ngClass]="{'done': uploadedSignedContract}">
                            Signed Contract
                        </div>
                        <div class="col-3 font-mont-book document-type" [ngClass]="{'done': uploadedVoidedCheck}">
                            Voided Check
                        </div>
                        <div class="col-6 font-mont-book document-type"
                            [ngClass]="{'done': uploadedFrontDL && uploadedBackDL}">
                            Driver's License
                        </div>
                    </div>
                </div>
                <hr>
                <div class="container checklist">
                    <div class="row">
                        <div class="col-12 title font-mont-regular">
                            Document Checklist:
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <ul>
                                <li class="font-mont-book">
                                    What type of signature is on the agreement document that you attached
                                    <select id="signatureType" placeholer>
                                        <option value="" disabled selected hidden>Select from list</option>
                                        <option value="eSign">eSign Documents</option>
                                        <option value="penSigned">Pen Signed Documents</option>
                                        <option value="Unsigned">Unsigned Documents</option>
                                    </select>
                                </li>
                                <li class="font-mont-book">
                                    Did you include a voided check?
                                    <span>
                                        <input type="radio" id="voidedCheckTrue" name="voidedCheck" value="true">
                                    </span>
                                    <label for="voidedCheckTrue">Yes</label>
                                    <span>
                                        <input type="radio" id="voidedCheckFalse" name="voidedCheck" value="false">
                                    </span>
                                    <label for="voidedCheckFalse">No</label>
                                </li>
                                <li class="font-mont-book">
                                    Did you upload a US issued photo ID (not expired)?
                                    <span>
                                        <input type="radio" id="photoIDTrue" name="photoID" value="true">
                                    </span>
                                    <label for="photoIDTrue">Yes</label>
                                    <span>
                                        <input type="radio" id="photoIDFalse" name="photoID" value="false">
                                    </span>
                                    <label for="photoIDFalse">No</label>
                                </li>
                                <li class="font-mont-book">
                                    Did you upload a Delivery Acknowledgement?
                                    <span>
                                        <input type="radio" id="deliveryAckTrue" name="deliveryAck" value="true">
                                    </span>
                                    <label for="deliveryAckTrue">Yes</label>
                                    <span>
                                        <input type="radio" id="deliveryAckFalse" name="deliveryAck" value="false">
                                    </span>
                                    <label for="deliveryAckFalse">No</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="container">
                </div>
            </div>
        </div>
    </div>
    <app-drag-drop></app-drag-drop>
    <app-error-dialog [modalId]="errorId" [title]="errorTitle" [messageA]="errorMessageA" [messageB]="errorMessageB"
        [messageC]="errorMessageC" [messageBClass]="errorMessageBClass" [dialogClass]="'w600'">
    </app-error-dialog>
</div>